import * as TYPES from './types';
export default {
    [TYPES.SET_LIST](payload) {
        this.list = [...payload];
    },
    [TYPES.SET_CURRENT_LIST](payload) {
        this.currentList = [...payload];
    },
    [TYPES.SET_START_INDEX](payload) {
        this.startIndex = payload;
    },
};
